import { render, staticRenderFns } from "./detailsTJ.vue?vue&type=template&id=de8402ec&scoped=true&"
import script from "./detailsTJ.vue?vue&type=script&lang=js&"
export * from "./detailsTJ.vue?vue&type=script&lang=js&"
import style0 from "./detailsTJ.vue?vue&type=style&index=0&id=de8402ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8402ec",
  null
  
)

export default component.exports